import { Button } from "@/components/ui/button";
import { ArrowRight, Phone, Shield, Star } from "lucide-react";

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative overflow-hidden bg-[#0F172A]">
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src="https://images.pexels.com/photos/30580640/pexels-photo-30580640.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600"
          alt="Modern home exterior"
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#0F172A] via-[#0F172A]/95 to-[#0F172A]/70" />
        <div className="absolute inset-0 hero-grid opacity-40" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32 lg:py-40">
        <div className="max-w-3xl">
          <div
            data-testid="hero-eyebrow"
            className="fade-up inline-flex items-center gap-2 px-4 py-2 rounded-full border border-white/20 bg-white/5 backdrop-blur text-white/90 text-xs uppercase tracking-widest font-semibold mb-8"
          >
            <span className="w-2 h-2 rounded-full bg-[#E31837] animate-pulse" />
            Lennox Dealer · Hiawatha, KS
          </div>

          <h1
            data-testid="hero-title"
            className="fade-up delay-100 font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-7xl leading-[1.05] tracking-tight"
          >
            Reliable heating &amp; cooling for{" "}
            <span className="text-[#E31837]">Hiawatha</span>, Kansas.
          </h1>

          <p
            data-testid="hero-subtitle"
            className="fade-up delay-200 mt-6 text-lg sm:text-xl text-slate-300 max-w-2xl leading-relaxed"
          >
            Family-owned HVAC specialists installing and servicing trusted Lennox systems.
            Comfort you can count on — backed by 24/7 emergency response.
          </p>

          <div className="fade-up delay-300 mt-10 flex flex-col sm:flex-row gap-3">
            <Button
              data-testid="hero-book-btn"
              onClick={() =>
                document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" })
              }
              className="rounded-full bg-[#E31837] hover:bg-[#C8102E] text-white px-8 h-14 text-base font-semibold shadow-lg hover:shadow-2xl hover:-translate-y-0.5 transition-all"
            >
              Book Appointment <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
            <a href="tel:7852880330" data-testid="hero-call-btn">
              <Button
                variant="outline"
                className="rounded-full bg-transparent border-2 border-white/30 text-white hover:bg-white hover:text-slate-900 px-8 h-14 text-base font-semibold transition-all w-full sm:w-auto"
              >
                <Phone className="mr-2 w-5 h-5" /> 785-288-0330
              </Button>
            </a>
          </div>

          <div className="fade-up delay-300 mt-12 flex flex-wrap items-center gap-x-8 gap-y-3 text-sm text-slate-300">
            <div className="flex items-center gap-2">
              <Shield className="w-4 h-4 text-[#E31837]" /> Licensed &amp; Insured
            </div>
            <div className="flex items-center gap-2">
              <Star className="w-4 h-4 text-[#E31837]" fill="#E31837" /> 5-Star local reviews
            </div>
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-[#E31837]" /> 24/7 Emergency Service
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
